import request from '@/utils/request';

// 查询部门列表
export function listDept(query) {
    return request({
        url: '/app/dept/list',
        method: 'get',
        params: query,
        headers: {
            isToken: false
        },
    });
};

export function addDept(query) {
    return request({
        url: '/app/dept',
        method: 'post',
        data: query,
    });
};

export function updateDept(query) {
    return request({
        url: '/app/dept',
        method: 'put',
        data: query,
    });
};

export function removeDept(id) {
    return request({
        url: `/app/dept/${id}`,
        method: 'delete',
    });
};
